import type { FullMenuCatalog } from 'features/menu-page/domain';

export function useProductNameList(props: Props) {
  const { customGroupId, catalog } = props;

  const _MAX_LENGTH = 2;

  const _fullNames = catalog.customizationGroups
    .filter(cg => cg.id === customGroupId)
    .map(cg => catalog.products.find(p => p.id === cg.productId)?.name);

  const fnsLen = _fullNames.length;
  const showRestNames = fnsLen > _MAX_LENGTH;
  const restNamesLength = fnsLen - _MAX_LENGTH;
  const names = _fullNames.slice(0, _MAX_LENGTH).join(', ');
  const restNames = _fullNames.slice(_MAX_LENGTH).join(', ');

  return {
    showRestNames,
    restNamesLength,
    names,
    restNames,
  };
}

interface Props {
  customGroupId: number;
  catalog: FullMenuCatalog;
}
